import Insights from "../insights/Insights";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { Code } from "@connectrpc/connect";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import React from "react";

export default function InsightsDashboard() {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <ErrorBoundary
      onReset={reset}
      fallbackRender={(props) => <FallbackRender {...props} />}
    >
      <Insights />
    </ErrorBoundary>
  );
}

function FallbackRender(props: FallbackProps) {
  const { error, resetErrorBoundary } = props;
  const theme = useTheme();

  if (error != null) {
    if (error.code === Code.Unauthenticated) {
      window.location.replace("/login/github");

      return;
    }
  }

  return (
    <div>
      <Stack direction="column" alignItems="start" gap={3}>
        <Typography variant="h5">Failed to retrieve insights</Typography>
        Encountered an error while fetching:
        <Typography
          component="code"
          sx={{
            backgroundColor: theme.palette.grey.A100,
            padding: theme.spacing(1.5),
            borderRadius: theme.spacing(0.5),
            fontFamily: "monospace",
          }}
        >
          {error.message}
        </Typography>
        <Button variant="contained" onClick={() => resetErrorBoundary()}>
          Try again
        </Button>
      </Stack>
    </div>
  );
}
